module.exports = __webpack_public_path__ + "img/vediobj.e69b370a.jpg";